import { render } from "./AtencionesPorDiag.vue?vue&type=template&id=529ffa84&scoped=true"
import script from "./AtencionesPorDiag.vue?vue&type=script&lang=js"
export * from "./AtencionesPorDiag.vue?vue&type=script&lang=js"

import "./AtencionesPorDiag.vue?vue&type=style&index=0&id=529ffa84&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529ffa84"]])

export default __exports__